<template>
    <div class="fullh">
        <div id="table-login" class="table">
            <div class="table-cell padtop">
                <header-login></header-login>
                <login-container></login-container>
            </div>
        </div>
        <footer class="footer" id="footer">
            <div class="footer" id="footer_bg"></div>
            <div class="container">
                <div class="row footer-extra-games">
                    <div class="col-lg-4 col-md-5 col-sm-6 col-xs-6">
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-6 col-xs-6 text-right pull-right">
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    import HeaderLogin from './../header-login-component/HeaderLoginComponent.vue'
    import LoginContainer from './../login-container-component/LoginContainerComponent.vue'

    export default {
        components: {HeaderLogin, LoginContainer}
    }
</script>